import { useState } from "react";
import { X } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";

/** Chip-style free-form tag input. Type + Enter (or comma) to add a tag.
 *  Tags are normalized to lowercase, trimmed, deduped. */
export const TagInput = ({ value = [], onChange, placeholder = "Add a tag and press Enter…" }) => {
  const [draft, setDraft] = useState("");

  const commit = (raw) => {
    const cleaned = (raw || "")
      .split(",")
      .map((t) => t.trim().toLowerCase())
      .filter(Boolean);
    if (cleaned.length === 0) return;
    const next = Array.from(new Set([...(value || []), ...cleaned]));
    onChange(next);
    setDraft("");
  };

  const removeAt = (idx) => {
    const next = value.filter((_, i) => i !== idx);
    onChange(next);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      commit(draft);
    } else if (e.key === "Backspace" && !draft && value.length) {
      e.preventDefault();
      removeAt(value.length - 1);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2">
        {value.map((t, i) => (
          <Badge
            key={`${t}-${i}`}
            variant="secondary"
            className="rounded-full px-3 py-1 gap-1 text-sm"
          >
            {t}
            <button
              type="button"
              onClick={() => removeAt(i)}
              className="ml-1 rounded-full hover:bg-muted-foreground/20 p-0.5"
              aria-label={`Remove tag ${t}`}
            >
              <X className="w-3 h-3" />
            </button>
          </Badge>
        ))}
      </div>
      <Input
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={() => draft && commit(draft)}
        placeholder={placeholder}
        data-testid="tag-input"
      />
    </div>
  );
};
